import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ErrorStore {
  errorMessage?: string;
  setErrorMessage: (errorMessage?: string) => void;
  successFeedbackMessage?: string;
  setSuccessFeedbackMessage: (successFeedbackMessage?: string) => void;
}

export const useErrorStore = create<ErrorStore>()(
  devtools((set) => ({
    errorMessage: undefined,
    setErrorMessage: (errorMessage) => {
      return set({ errorMessage });
    },
    successFeedbackMessage: undefined,
    setSuccessFeedbackMessage: (successFeedbackMessage) => {
      return set({ successFeedbackMessage });
    },
  }))
);

export const setErrorMessage = (e?: Error) => {
  useErrorStore
    .getState()
    .setErrorMessage(e?.message || 'An unexpected error occurred');
};

export const setSuccessFeedbackMessage = (message: string) => () => {
  useErrorStore.getState().setSuccessFeedbackMessage(message);
};